var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticClass: "hotsugg-header" }, [
    _c("form", { attrs: { action: "/v", "accept-charset": "utf-8" } }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.oquery,
            expression: "oquery",
          },
        ],
        attrs: {
          id: "keyword",
          name: "query",
          type: "text",
          autocomplete: "off",
        },
        domProps: { value: _vm.oquery },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.oquery = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _vm.oquery
        ? _c("button", {
            staticClass: "icon_cancel",
            attrs: { id: "resetbtn", type: "reset" },
            on: { click: _vm.reset },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("input", { attrs: { type: "hidden", name: "w", value: "06009900" } }),
      _vm._v(" "),
      _c("input", { attrs: { type: "hidden", name: "ie", value: "utf8" } }),
      _vm._v(" "),
      _vm.spver
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.spver,
                expression: "spver",
              },
            ],
            attrs: { type: "hidden", name: "spver" },
            domProps: { value: _vm.spver },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.spver = $event.target.value
              },
            },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "header_search_cancel",
        attrs: { id: "cancleBtn", href: "javascript:history.go(-1)" },
      },
      [_vm._v("取消")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }